<template>
  <div class="container-title" :style="{paddingTop: paddingTop + 'px', height: paddingTop + 54 +'px'}">
    <span class="title"><slot/></span>
  </div>
</template>
<script>
  export default{
    props:{
      paddingTop:{
        type: Number,
        default:80
      }
    }
  }
</script>
<style scoped>
.container-title{position: relative;width: 100%;}
.container-title .title{
  font-size: 36px;
  line-height: 36px;
  font-weight: 500;
  color: #111111;
  text-align: center;
  display: block;
  position: relative;
}
.container-title .title::after {
content: "";
display: block;
position: absolute;
width: 50px;
height: 3px;
background-color: #BF1A20;
left: 50%; /* 左侧位置为父元素宽度一半 */
transform: translateX(-50%); /* 水平居中 */
bottom: -18px;
}
</style>